<template>
  <div class="flex flex-col p-2">
    <div class="w-full">
      <div class="grid grid-cols-5 gap-3 py-3">
        <input type="text"
               v-model="name"
               placeholder="Search by Name"
               required
               class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
               @keyup.enter="fetch(1)"/>
        <input type="text"
               v-model="brn"
               placeholder="Search by BRN"
               required
               class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
               @keyup.enter="fetch(1)"/>
        <input
            type="text"
            v-model="email"
            placeholder="Search by Email"
            required
            class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
            @keyup.enter="fetch(1)"/>
        <input
            type="text"
            v-model="phone"
            placeholder="Search by phone"
            required
            class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
            @keyup.enter="fetch(1)"/>
        <select v-model="status" @change="fetch(1)"
                class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent">
          <option :value="null">--Filter by Status--</option>
          <option :value="null">All</option>
          <option value="ACTIVE">Active</option>
          <option value="INACTIVE">Inactive</option>
        </select>
      </div>
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <table class="min-w-full leading-normal">
            <thead>
            <tr class="border-b border-t border-gray-200">
              <th>Name</th>
              <th>BRN</th>
              <th>Entity Type</th>
              <th>Entity Sub Type</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Date Created</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
            </thead>

            <tbody>
            <template v-if="loading">
              <tr v-for="i in 6" :key="`sk-${i}`" class="animate-pulse">
                <td>
                  <div class="h-3 bg-gray-200 rounded w-full"></div>
                </td>
                <td>
                  <div class="h-3 bg-gray-200 rounded w-full"></div>
                </td>
                <td>
                  <div class="h-3 bg-gray-200 rounded w-full"></div>
                </td>
                <td>
                  <div class="h-3 bg-gray-200 rounded w-full"></div>
                </td>
                <td>
                  <div class="h-3 bg-gray-200 rounded w-full"></div>
                </td>
                <td>
                  <div class="h-3 bg-gray-200 rounded w-full"></div>
                </td>
                <td>
                  <div class="h-3 bg-gray-200 rounded w-full"></div>
                </td>
                <td>
                  <div class="h-3 bg-gray-200 rounded w-full"></div>
                </td>
                <td>
                  <div class="h-3 bg-gray-200 rounded w-full"></div>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr :class="[(idx%2) ? rows.even : rows.odd]" v-for="(account, idx) in accounts" :key="idx">
                <td class="font-bold text-uppercase">
                  <span>{{ account.name }}</span>
                </td>
                <td>
                  <span>{{ account.brn }}</span>
                </td>
                <td>
                  <span>{{ cleanEntityType(account.businessType) }}</span>
                </td>
                <td>
                  <span>{{ cleanEntityType(account.businessSubType) }}</span>
                </td>
                <td>
                  <span>
                    <i class="fa fa-check-circle text-green mx-1" v-if="account.emailVerified"></i>
                    <i class="fa fa-times text-orange mx-1" v-else></i>
                    {{ account.email }}
                  </span>
                </td>
                <td>
                  <span>
                    <i class="fa fa-check-circle text-green mx-1" v-if="account.phoneVerified"></i>
                    <i class="fa fa-times text-orange mx-1" v-else></i>
                    {{ account.phoneNumber }}
                  </span>
                </td>
                <td><span>{{ formatDate(account.createdAt) }}</span></td>
                <td class="font-bold">
                  <span class="text-green" v-if="account.enabled">Active</span>
                  <span class="text-red" v-else>Inactive</span>
                </td>
                <td>
                  <div class="flex gap-1 items-center">
                    <button class="btn-sm-danger" v-if="account.enabled" @click="changeStatus(account.id,'INACTIVE')"
                            title="Click to disable account">
                      <i class="fa fa-times mr-1"></i> Disable
                    </button>
                    <button class="btn-sm-primary" v-else @click="changeStatus(account.id,'ACTIVE')"
                            title="Click to activate account">
                      <i class="fa fa-check mr-1"></i> Enable
                    </button>
                    <button class="btn-sm-primary" v-if="!account.enabled" @click="resendActivation(account.id)"
                            title="Click to resend activation link">
                      <i class="fa fa-reply mr-1"></i> Resend
                    </button>
                    <button class="btn-sm-primary" v-if="!account.enabled" @click="openEditBusinessForm(account)"
                            title="Click to edit account">
                      <i class="fa fa-pen-square mr-1"></i> Edit
                    </button>
                  </div>
                </td>
              </tr>
              <tr>
                <td v-if="accounts.length === 0" colspan="9" class="text-center py-6 text-sm text-gray-400">
                  No results found
                </td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
      </div>
      <div v-if="pagination.totalPages > 1"
           class="flex items-center justify-between px-1 py-3 border-t border-gray-100 mt-2">
        <p class="text-xs text-gray-500">Page <span class="font-semibold text-gray-700">{{ currentPage }}</span> of
          <span class="font-semibold text-gray-700">{{ pagination.totalPages }}</span></p>
        <div class="flex gap-2">
          <button class="btn-sm-primary" @click="previous" :disabled="currentPage === 1">
            <i class="fa fa-chevron-left mr-1"></i> Prev
          </button>
          <button class="btn-sm-primary" @click="next" :disabled="currentPage === pagination.totalPages">
            Next <i class="fa fa-chevron-right ml-1"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <AppModal v-model="showEditAccountForm" size="lg" title="Edit Account" hide-footer>
    <div class="col-span-11 mx-auto">
      <div class="grid grid-cols-12 gap-4">

        <div class="col-span-12">

          <label>BRN</label>

          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" :disabled="true"  v-model="editForm.brn"
                 placeholder="BRN" />
        </div>
      </div>
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" :disabled="true"  v-model="editForm.name"
                 placeholder="Name" />
        </div>
      </div>
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" v-model="editForm.email"
                 placeholder="Email Address" />
        </div>
        <div class="col-span-12">
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" v-model="editForm.phoneNumber"
                 placeholder="Phone Number" />
        </div>
      </div>


      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-10"></div>
        <div class="col-span-2">
          <button class="btn-primary w-full bg-primary text-white px-2 py-1 rounded-md"
                  @click="updateUserDetails">
            <i class="fa fa-save mx-1"></i> Save changes
          </button>
        </div>
      </div>
    </div>
  </AppModal>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import { useAccountStore } from "../stores";
import { useConfirmDialog } from "@/composables";
import AppModal from "@/components/ui/AppModal.vue";
import { cleanEntityType, formatDate, objectToQueryParams } from "@/commons/composables/utilities.ts";
import { useNotificationsStore } from "@/app/notify/notifications.ts";
import { BusinessAccount } from "@/domains/home/services/accounts/types";

interface Account {
    id: string
    name: string
    brn: string
    businessType: string
    businessSubType: string
    email: string
    phoneNumber: string
    createdAt: string
    enabled: boolean
    emailVerified: boolean
    phoneVerified: boolean
}

interface EditForm {
    userId: string | null
    brn: string | null
    name: string | null
    email: string | null
    phoneNumber: string | null
}

interface Pagination {
    totalElements: number
    totalPages: number
}

const accountStore = useAccountStore();
const notify = useNotificationsStore();
const { showConfirm } = useConfirmDialog();

const showEditAccountForm = ref(false)
const loading = ref(false)
const currentPage = ref(1)
const limit = ref(10)
const accounts = ref<BusinessAccount[]>([]);
const pagination = ref<Pagination>({
    totalElements: 0,
    totalPages: 0
})
const rows = ref({
    odd: "border-t border-gray-200 hover:bg-gray-10",
    even: "border-t border-gray-200 bg-gray-10"
})
const status = ref<string | null>(null)
const email = ref<string | null>(null)
const name = ref<string | null>(null)
const brn = ref<string | null>(null)
const phone = ref<string | null>(null)
const editForm = ref<EditForm>({
    userId: null,
    brn: null,
    name: null,
    email: null,
    phoneNumber: null,
})

onMounted(() => {
    fetch()
})

const fetch = (startPage: number | null = null) => {
    loading.value = true
    let filters: any = { "accountType": "BUSINESS" }

    if (status.value) {
        filters.accountStatus = status.value
    }
    if (name.value) {
        filters.name = name.value
    }
    if (email.value) {
        filters.email = email.value
    }
    if (brn.value) {
        filters.brn = brn.value
    }
    if (phone.value) {
        filters.phone = phone.value
    }

    filters.page = startPage ? startPage : currentPage.value
    filters.perPage = limit.value

  accountStore.fetchBusinessAccounts(objectToQueryParams(filters));
}

const next = () => {
    if (currentPage.value < pagination.value.totalPages) {
        currentPage.value++
        fetch()
    }
}

const changeStatus = async (userId: string, status: string) => {
    const confirmed = await showConfirm(`Are you sure you want to change this account status to ${status.toLowerCase()}?`)
    if (confirmed) {
        accountStore.changeAccountStatus({ userId, status })
    }
}

const resendActivation = (userId: string) => {
  accountStore.doResendActivationLink({ userId });
}

const previous = () => {
    if (currentPage.value > 1) {
        currentPage.value--
        fetch()
    } else {
        notify.warning("No more data to show")
    }
}

const openEditBusinessForm = (account: BusinessAccount) => {
    editForm.value = {
        userId: account.id,
        brn: account.brn,
        name: account.name,
        email: account.email,
        phoneNumber: account.phoneNumber,
    }
    showEditAccountForm.value = true
}

const updateUserDetails = () => {
    let data = {
        "email": editForm.value.email,
        "phone": editForm.value.phoneNumber,
        "userId": editForm.value.userId
    }

  accountStore.updateStaffContacts(data);
}

const closeEditForm = () => {
    showEditAccountForm.value = false
}

// Watchers
watch(() => accountStore.business_accounts, (data) => {
  if (data) {
        loading.value = false
    accounts.value = data;
        pagination.value = {
          totalPages: accountStore.pagination?.data.totalPages || 1,
          totalElements: accountStore.pagination?.data.totalElements || 1
        }
    }
})

watch(() => accountStore.reactivationSuccess, (data) => {
    if (data) {
        notify.success(data.message)
        loading.value = true
        closeEditForm()
        fetch()
    }
})

watch(() => accountStore.reactivationError, (error) => {
    if (error) {
        notify.error(error.message)
    }
})
</script>
